import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import AssuredWorkloadIcon from '@mui/icons-material/AssuredWorkload';
import * as constants from '../../../../../constants'
import Icon from '../../../../UI/Icon/Icon'
import { Stack, Typography } from '@mui/material'
import { BsCalendar2Week, BsClipboardData, BsFolder, BsFolder2Open, BsPatchCheck } from 'react-icons/bs'
import { HiOutlineBriefcase, HiOutlineUserGroup } from 'react-icons/hi2'
import { TfiWallet } from "react-icons/tfi";
// import {ReactComponent as MeetingIcon} from '../../../../../assets/images/Meeting.svg'
import { LiaCubesSolid } from 'react-icons/lia'
import context from 'context/auth-context'
const NavigationItem = props => {
  const authContext = useContext(context)
  const links = React.useMemo(() => {
    return authContext.companyCode !== 'dev' && authContext.companyCode !== 'dev25'?
        props.links.filter(x => x['link'] !== '/risks' && x['link'] !== '/evaluations'  && x['link'] !== '/compliance')
        : props.links
    // return props.links
  }, [authContext.companyCode, props.links])
  return (
    links.map(link => {
      return (
        !link.hasChildren
          ? <li key={link.title} className={link.isActive ? 'site-menu-item active' : 'site-menu-item'}>
                        <Link to={link.link} onClick={props.onBachelorLinkClick.bind(this, link.title)}>
                            <Stack alignItems='center' spacing={2}>
                                {
                                    (() => {
                                      switch (link.link) {
                                        case '/evaluations':
                                          return <BsClipboardData color={link.isActive ? '#ffff' : 'rgba(158, 158, 158, 0.9)'} size={25} />
                                        case '/budgets':
                                          return <TfiWallet color={link.isActive ? '#ffff' : 'rgba(158, 158, 158, 0.9)'} size={25} />
                                        case '/dashboard':
                                          return <BsCalendar2Week color={link.isActive ? '#ffff' : 'rgba(158, 158, 158, 0.9)'} size={25} />
                                        case '/groups':
                                          return <HiOutlineUserGroup color={link.isActive ? '#ffff' : 'rgba(158, 158, 158, 0.9)'} size={30} />
                                        case '/resources':
                                          return link.isActive ? <BsFolder2Open color="#ffff" size={25} /> : <BsFolder color="rgba(158, 158, 158, 0.9)" size={25} />
                                        case '/approvals':
                                          return <BsPatchCheck color={link.isActive ? '#ffff' : 'rgba(158, 158, 158, 0.9)'} size={25} />
      
                                        case '/meetings':
                                          return <HiOutlineBriefcase color={link.isActive ? '#ffff' : 'rgba(158, 158, 158, 0.9)'} size={30} />
                                        case '/risks':
                                          return <LiaCubesSolid color={link.isActive ? '#ffff' : 'rgba(158, 158, 158, 0.9)'} size={33} />
                                        default:
                                          return <Icon iconClass={`site-menu-icon ${link.iconClass}`} aria-hidden="true" />
                                      }
                                    })()
                                }
                                <Typography sx={{ color: link.isActive ? '#ffff' : 'rgba(158, 158, 158, 0.9)', fontFamily: 'inherit', fontWeight: 700 }}>{link.title}</Typography>
                                {/* <span className="site-menu-title">{link.title}</span> */}
                            </Stack>

                        </Link>
                    </li>
          :  <li key={link.title} className={link.isActive ? 'site-menu-item has-sub active open' : 'site-menu-item has-sub'}>
                        <Link to={link.link}>
                            <Icon iconClass={`site-menu-icon ${link.iconClass}`} aria-hidden="true" />
                            <span className="site-menu-title">{link.title}</span>
                        </Link>
                        <ul className="site-menu-sub">
                            {
                                link.theChildren.map(child => {
                                  return (
                                    !child.hasChildren
                                      ? <li key={child.title} className={child.isActive ? 'site-menu-item active' : 'site-menu-item'}>
                                                <Link to={child.link} onClick={props.onChildLinkClick.bind(this, link.title, child.title)}>
                                                    <span className="site-menu-title">{child.title}</span>
                                                </Link>
                                            </li>
                                      : <li key={child.title} className={child.isActive ? 'site-menu-item has-sub active open' : 'site-menu-item has-sub'}>
                                                <Link to={child.link}>
                                                    <span className="site-menu-title">{child.title}</span>
                                                    <span className="site-menu-arrow"></span>
                                                </Link>
                                                <ul className="site-menu-sub">
                                                    {
                                                        child.theChildren.map(grandchild => {
                                                          return (
                                                                <li key={grandchild.title} className={grandchild.isActive ? 'site-menu-item active' : 'site-menu-item'}>
                                                                    <Link to={grandchild.link} onClick={props.onGrandchildLinkClick.bind(this, link.title, child.title, grandchild.title)}>
                                                                        <span className="site-menu-title">{grandchild.title}</span>
                                                                    </Link>
                                                                </li>
                                                          )
                                                        })
                                                    }
                                                </ul>
                                            </li>
                                  )
                                })
                            }
                        </ul>
                    </li>
      )
    })
  )
}

const mapStateToProps = state => {
  return {
    links: state.leftNavLinks.leftNavigationLinks
  }
}

const mapDispatchToProps = dispatch => {
  return {
    onBachelorLinkClick: (linkTitle) => dispatch({
      type: constants.BACHELOR_LINK_CLICKED,
      payload: { linkTitle }
    }),
    onChildLinkClick: (parentLinkTitle, childLinkTitle) => dispatch({
      type: constants.CHILD_LINK_CLICKED,
      payload: { parentLinkTitle, childLinkTitle }
    }),
    onGrandchildLinkClick: (grandparentLinkTitle, parentLinkTitle, grandchildLinkTitle) => dispatch({
      type: constants.GRAND_CHILD_LINK_CLICKED,
      payload: { grandparentLinkTitle, parentLinkTitle, grandchildLinkTitle }
    })
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationItem)
